/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pool_All_CountriesInputs */

const en_pool_all_countries = /** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Countries`)
};

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const bn_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const de_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const el_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const es_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const fr_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const hi_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const hu_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const id_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const it_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const ja_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const ko_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const nl_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const pl_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const pt_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const ru_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const sv_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const tr_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const uk_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const vi_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const zh_pool_all_countries = en_pool_all_countries;

/** @type {(inputs: Pool_All_CountriesInputs) => LocalizedString} */
const zh_hant_pool_all_countries = zh_pool_all_countries;

/**
* | output |
* | --- |
* | "All Countries" |
*
* @param {Pool_All_CountriesInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const pool_all_countries = /** @type {((inputs?: Pool_All_CountriesInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pool_All_CountriesInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_pool_all_countries(inputs)
	if (locale === "de") return de_pool_all_countries(inputs)
	if (locale === "el") return el_pool_all_countries(inputs)
	if (locale === "en") return en_pool_all_countries(inputs)
	if (locale === "es") return es_pool_all_countries(inputs)
	if (locale === "fr") return fr_pool_all_countries(inputs)
	if (locale === "hi") return hi_pool_all_countries(inputs)
	if (locale === "hu") return hu_pool_all_countries(inputs)
	if (locale === "id") return id_pool_all_countries(inputs)
	if (locale === "it") return it_pool_all_countries(inputs)
	if (locale === "ja") return ja_pool_all_countries(inputs)
	if (locale === "ko") return ko_pool_all_countries(inputs)
	if (locale === "nl") return nl_pool_all_countries(inputs)
	if (locale === "pl") return pl_pool_all_countries(inputs)
	if (locale === "pt") return pt_pool_all_countries(inputs)
	if (locale === "ru") return ru_pool_all_countries(inputs)
	if (locale === "sv") return sv_pool_all_countries(inputs)
	if (locale === "tr") return tr_pool_all_countries(inputs)
	if (locale === "uk") return uk_pool_all_countries(inputs)
	if (locale === "vi") return vi_pool_all_countries(inputs)
	if (locale === "zh") return zh_pool_all_countries(inputs)
	return zh_hant_pool_all_countries(inputs)
});